(function ($, Drupal, once) {
    Drupal.behaviors.or28 = {
        attach() {
            $(once('or28', 'body')).each(function () {

                $('.OR28').each(function(i, hostCarousel) {
                    let currentIndex = -1;
                    const introElements = '.OR28__left-container .MO13__content > *';
                    const $tabButton = $('.OR28__tab-button');
                    const $tabList = $('.OR28__tab-list');

                    const $hostCarousel = $(hostCarousel);

                    gsap.set('.OR28__tab-button', {
                        opacity: 0,
                        x: '-70px'
                    });

                    gsap.set(introElements, {
                        opacity: 0,
                        x: '-30%'
                    });

                    function getComponentInstance(context) {
                        return $(context).closest('.OR28');
                    }

                    function resetTab(el) {
                        gsap.set(el, {
                            x: '-20px',
                            y: 0
                        });
                    }

                    function tabEntrance(el) {
                        gsap.to(el, {
                            display: 'flex',
                            opacity: 1,
                            y: 0,
                            x: 0,
                            duration: 0.25,
                        });
                    }

                    function selectTab(index) {
                        if (currentIndex >= 0 && currentIndex !== index) {
                            gsap.to($hostCarousel.find(".OR28__tab").get(currentIndex), {
                                opacity: 0,
                                y: '20px',
                                duration: 0.35,
                                display: 'none',
                                onComplete: () => {
                                    resetTab($hostCarousel.find(".OR28__tab").get(currentIndex));
                                    tabEntrance($hostCarousel.find(".OR28__tab").get(index));
                                    currentIndex = index;
                                }
                            });
                        } else {
                            tabEntrance($hostCarousel.find(".OR28__tab").get(index));
                            currentIndex = index;
                        }
                    }

                    function handleTabSelection($tab) {
                        $hostCarousel.find('.OR28__tab-button-container').removeClass('OR28__tab-button-container--selected');
                        $tab.parent().addClass('OR28__tab-button-container--selected');
                        $hostCarousel.find($tabButton).attr('aria-selected', false);
                        $tab.attr('aria-selected', true);

                        selectTab($tab.attr('data-tab-index') - 1);
                    }

                    function handleAccordionSelection($panel) {
                        $hostCarousel.find($tabButton).attr('aria-selected', false);
                        $hostCarousel.find($tabButton).attr('aria-expanded', false);

                        const $activePanel = $hostCarousel.find('.OR28__tab-button-container--open');
                        allPanels.slideUp();
                        $hostCarousel.find('.OR28__tab-button-container').removeClass('OR28__tab-button-container--open');
                        const accordionHeader = $panel.parent();
                        accordionHeader.toggleClass('OR28__tab-button-container--open');
                        if (accordionHeader.hasClass('OR28__tab-button-container--open') && !$activePanel.is(accordionHeader)) {
                            accordionHeader.find('.OR28__accordion-content').slideDown();
                            accordionHeader.find('.OR28__tab-button').attr('aria-expanded', true).attr('aria-selected', true);
                        }

                        if ($activePanel.is(accordionHeader)) {
                            accordionHeader.removeClass('OR28__tab-button-container--open');
                        }
                        return false;
                    }

                    function initAria() {
                        $tabList.attr('role', 'tablist');
                        $tabList.attr('aria-live', 'polite');
                        $tabButton.attr('role', 'tab');
                        $tabButton.attr('aria-selected', false);

                        $tabButton.each((i, el) => {
                            const tabId = $(el).attr('data-tab-id');
                            let panelId = $(`.OR28__tab[data-tab-id=${tabId}]`).attr('id');
                            if (window.innerWidth < 1280) {
                                panelId = $(`.OR28__accordion-content[data-tab-id=${tabId}]`).attr('id');
                            }
                            $(el).attr('aria-controls', panelId);
                        });

                        if (window.innerWidth < 1280) {
                            $tabList.attr('data-behavior', 'accordion');
                            $tabButton.attr('aria-expanded', false);
                        }
                    }

                    function initComponent() {
                        $('.OR28__tab').each((i, el) => {
                            resetTab(el);
                        });

                        gsap.to('.OR28__tab-button', {
                            opacity: 1,
                            x: 0,
                            stagger: 0.1,
                        });

                        gsap.to(introElements, {
                            opacity: 1,
                            x: 0,
                            stagger: 0.2,
                        });

                        gsap.to('.OR28__tab-button', {
                            opacity: 1,
                            x: 0,
                            stagger: 0.8,
                        });

                        initAria();

                        if (window.innerWidth >= 1280) {
                            setTimeout(() => {
                                const firstButton = $($(hostCarousel).find('.OR28__tab-list .OR28__tab-button')[0]);

                                handleTabSelection(firstButton);
                            }, 250);
                        }
                    }

                    initComponent();

                    const allPanels = $hostCarousel.find('.OR28__tab-button-container .OR28__accordion-content').hide();

                    $hostCarousel.on('click', '.OR28__tab-button', function (event) {
                        if (window.innerWidth >= 1280) {
                            handleTabSelection($(this));
                        } else {
                            handleAccordionSelection($(this));
                        }
                    });
                });

            });
        },
    };
})(jQuery, Drupal, once);
